import { NgModule } from '@angular/core';
import { ConvertValuePipe } from './pipes/convert-value.pipe';
import { FormatBytesPipe } from './pipes/format-bytes.pipe';
import { ImplodePipe } from './pipes/implode.pipe';

@NgModule({
    declarations: [
        FormatBytesPipe,
        ImplodePipe,
        ConvertValuePipe,
    ],
    imports: [],
    providers: [],
    exports: [
        FormatBytesPipe,
        ImplodePipe,
        ConvertValuePipe,
    ]
})
export class CoreUtilsModule {}
